// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CleanList--next-sr-only--28nJEhm","dialog":"CleanList--dialog--2IbkIwT","workingBox":"CleanList--workingBox--1z0yf0X","btnGroup":"CleanList--btnGroup--2Xmio2Z"};